import React, { useState } from "react";
import "../style/Contact.css";
import contactBg from "../assets/manufature.png";
import { Phone, Send, User } from "lucide-react";

const Contact = () => {
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    const subject = `New Contact Message from ${name}`;
    const body = `
Name: ${name}
Phone: ${phone}

Message:
${message}
    `;

    window.location.href = `mailto:info@steadgeo.com?subject=${encodeURIComponent(
      subject
    )}&body=${encodeURIComponent(body)}`;
  };

  return (
    <section className="contact-section" id="contact">
      <div className="contact-card">

        {/* LEFT SIDE */}
        <div className="contact-left">
          <div className="contact-overlay"></div>

          <img src={contactBg} alt="Engineering" />

          <div className="contact-left-content">
            <span className="contact-tag">GET IN TOUCH</span>

            <h2>
              Building Modern <br />
              Engineering Solutions
            </h2>

            <p>
              STEADGEO Engineering & Projects delivers professional
              industrial, manufacturing, and project support services.
            </p>

            <div className="contact-info">
              <div className="info-box">
                <Phone size={18} />
                <span>0490 350 0300</span>
              </div>

              <div className="info-box">
                <Send size={18} />
                <span>info@steadgeo.com</span>
              </div>
            </div>
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="contact-right">

          <div className="form-top">
            <span>CONTACT FORM</span>
            <h3>Send Us a Message</h3>
          </div>

          <form onSubmit={handleSubmit} className="contact-form">

            <div className="input-box">
              <User size={18} />
              <input
                type="text"
                placeholder="Your Name"
                required
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </div>

            <div className="input-box">
              <Phone size={18} />
              <input
                type="tel"
                placeholder="Phone Number"
                required
                value={phone}
                onChange={(e) => setPhone(e.target.value)}
              />
            </div>

            <div className="input-box textarea-box">
              <textarea
                placeholder="Write your message..."
                required
                value={message}
                onChange={(e) => setMessage(e.target.value)}
              ></textarea>
            </div>

            <button type="submit" className="send-btn">
              Send Message
            </button>

          </form>
        </div>

      </div>
    </section>
  );
};

export default Contact;